// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"380":"f0806840","1955":"f0806840","3320":"f0806840","3631":"f0806840","8138":"f0806840","9033":"f0806840","9299":"f0806840"}[chunkId] + ".chunk.css";
};